export default __webpack_public_path__ + "static/media/b55a8c615d305ad1fefb524de4d92bb51580330374352.1fbefda2.webp";